import React from 'react'
import { useNavigate } from "react-router-dom";

const Sidebar = ({ navigation, subPageName }) => {
  let navigate = useNavigate();
  function classNames(...classes) {
      return classes.filter(Boolean).join(' ')
  }
  const RedirectionControl = (event, title) => {
    event.preventDefault();
    switch (title) {
      case "getting":
        navigate("/Started");
        break;
      case "introduction":
        navigate("/Started/introduction");
        break;
      case "leadMangement":
        navigate("/Started/leadMangement");
        break;
      default:
        break;
    }
  };

  return (
    <div className="hidden h-[88%] lg:fixed lg:inset-y-[13%] lg:z-10 lg:flex lg:w-72 lg:flex-col">
      {/* Sidebar component, swap this element with another sidebar if you like */}
      <div className="flex grow flex-col gap-y-5 overflow-y-auto  bg-white px-6 pb-4">
        {/* <div className='text-base font-[600] pt-1 pb-4 border-b border-gray-200 cursor-default'>User Settings</div> */}
          <nav className="flex flex-1 flex-col ">
          {/* <div className="text-xs font-semibold leading-6 text-gray-400">Input</div> */}
            <ul role="list" className="flex flex-1 flex-col gap-y-2">
              <li>
                <ul role="list" className="-mx-2 space-y-1">
                  {navigation.map((item,index) => (
                    (<li key={item.name} className='cursor-pointer'>
                      {/* {index == 0 &&<div className="text-xs ml-2 mb-2 font-semibold leading-6 text-gray-400 cursor-default">Input</div>} */}
                      <span
                        className={classNames(
                          item?.nav_name?.includes(subPageName)
                            ? 'bg-gray-50 text-[var(--brand-primary)]'
                            : 'text-[var(--brand-secondary)] hover:text-[var(--brand-primary)] hover:bg-gray-50',
                          'group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold'
                        )}
                        onClick={(e) => {
                          RedirectionControl(e, item.current);
                        }}
                      >
                        {/* <item.icon
                          className={classNames(
                              item?.nav_name?.includes(subPageName) ? 'text-[var(--brand-primary)]' : 'text-gray-400 group-hover:text-[var(--brand-primary)]',
                            'h-6 w-6 shrink-0'
                          )}
                          aria-hidden="true"
                        /> */}
                        {item.name}
                      </span>
                    </li>)
                  ))}
                </ul>
              </li>
            </ul>
          </nav>
        </div>
      </div>
  )
}

export default Sidebar